import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie as RePie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Surface,
  Symbols,
} from "recharts";
import { colors } from "./colors";
import { useStyles } from "./styles";

export function Pie({ data, dataKey = "value", nameKey = "name" }) {
  const styles = useStyles();
  const [newData, setNewData] = useState(data);
  const [chartData, setChartData] = useState([]);
  const [activeLegend, setActiveLegend] = useState([]);
  const [disabledLegend, setDisabledLegend] = useState([]);

  useEffect(() => {
    const tempData = data.map((dt, index) => ({
        ...dt,
        id: index,
        color: colors[index % colors.length],
      })),
      tempLegend = tempData.map((dt) => ({
        id: dt.id,
        value: dt[nameKey],
        color: dt.color,
        type: "circle",
      }));
    setNewData(tempData);
    setChartData(tempData);
    setActiveLegend(tempLegend);
  }, [data, nameKey]);

  function _filterChart(id) {
    let _disabled = [];
    if (disabledLegend.includes(id)) {
      _disabled = disabledLegend.filter((idDisabled) => idDisabled !== id);
    } else {
      _disabled = disabledLegend.concat(id);
    }
    const newChartData = newData.filter((dt) => !_disabled.includes(dt.id));
    setChartData(newChartData);
    setDisabledLegend(_disabled);
  }

  function LegendComponent({ payload }) {
    return (
      <div className={styles.rootLegend}>
        {payload.map((entry, index) => {
          const { id, color, value } = entry,
            active = disabledLegend.includes(id),
            style = { color: active ? "#AAA" : "#000" };

          return (
            <span
              key={index.toString()}
              className={styles.textLegend}
              style={style}
              onClick={() => _filterChart(id)}
            >
              <Surface
                width={10}
                height={10}
                viewBox={{ x: 0, y: 0, height: 10, width: 10 }}
              >
                <Symbols cx={5} cy={5} type="circle" size={50} fill={color} />
                {active && (
                  <Symbols
                    cx={5}
                    cy={5}
                    type="circle"
                    size={25}
                    fill={"#FFF"}
                  />
                )}
              </Surface>
              <span>{value}</span>
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <ResponsiveContainer width="100%">
        <PieChart>
          <Tooltip
            contentStyle={{ borderRadius: 15 }}
            formatter={(value, name) => [value, name]}
          />
          <Legend
            verticalAlign="bottom"
            payload={activeLegend}
            content={LegendComponent}
          />

          <RePie data={chartData} dataKey={dataKey} nameKey={nameKey} label>
            {chartData &&
              chartData.map((dt, index) => (
                <Cell key={index.toString()} fill={dt.color} />
              ))}
          </RePie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
